import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-trash.svg";
import * as styles from "./Icon.module.scss";

type TrashProps = React.SVGProps<SVGSVGElement>;

export const Trash = ({ className, ...props }: TrashProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
